import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { Button } from '../../../../common';
import { Team } from '../../../../types/generated.types';

// Configure dayjs to use ISO week
dayjs.extend(isoWeek);

interface ExtendSalesPeriodModalProps {
  closeModal: () => void;
  team: Team;
  onConfirm: () => void;
  isExtending: boolean;
}

const PeriodInfo: React.FC<{ team: Team }> = ({ team }) => {
  if (!team.salesStartDate || !team.salesEndDate) {
    return (
      <div className="period-info">
        <p><strong>Din säljperiod ändras</strong></p>
      </div>
    );
  }

  const startWeek = dayjs(team.salesStartDate).isoWeek();
  const extendedWeek = dayjs(team.salesEndDate).add(7, 'day').isoWeek();

  return (
    <div className="period-info">
      <p>
        <strong>Din säljperiod ändras till</strong>
      </p>
      <p>
        Vecka {startWeek} - Vecka {extendedWeek}
      </p>
    </div>
  );
};

const ExtendSalesPeriodModal: React.FC<ExtendSalesPeriodModalProps> = ({
  closeModal,
  team,
  onConfirm,
  isExtending
}) => {
  const handleClickOutside = (event: React.MouseEvent) => {
    if ((event.target as HTMLElement).className === 'modal extend-sales-modal') {
      closeModal();
    }
  };

  return (
    <div className="modal extend-sales-modal" onClick={handleClickOutside}>
      <div className="extend-sales box">
        <IoCloseSharp size={24} className="close" onClick={closeModal} />
        <h3>Förläng försäljningsperiod</h3>
        <p>Vad kul att du vill förlänga perioden och sälja mer!</p>
        <PeriodInfo team={team} />
        <p>Notera att utbetalningen också förlängs med en vecka.</p>
        <Button
          className='primary lg'
          onClick={onConfirm}
          loading={isExtending}
        >
          {isExtending ? 'Förlänger...' : 'Ja, förläng'}
        </Button>
      </div>
    </div>
  );
};

export default ExtendSalesPeriodModal; 
